import React from 'react'
import MyProject from "../Components/Projects/Myproject";

function ProjectPage() {
  return (
      <>
          <main>
              <article id="fullpage">
                  <MyProject/>
              </article>
          </main>
    </>
  )
}

export default ProjectPage;